import { message } from "antd";
import { axiosGet, axiosPatch } from "../axios";

export const getAppointments = async ({
  pageNumber = 1,
  pageSize = 3,
  text,
}) => {
  try {
    const res = await axiosGet({
      path: `appointment/list?pageNumber=${pageNumber}&itemPerPage=${pageSize}${
        text ? `&text=${text}` : ""
      }`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const appointmentRescheduled = async (id, payload) => {
  try {
    const res = await axiosPatch({
      path: `appointment/${id}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const appointmentSettings = async (id, payload) => {
  try {
    const res = await axiosPatch({
      path: `appointment/service/${id}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
